import type { GetSettlementWithIdentificationData } from '~/api-spec/__generated__/main'
import type { GetSettlement1Data, GetSettlementParams } from '~/api-spec/__generated__/pod'
import { httpClient, type RequestConfig, type RequestMeta } from '~/http/client'

import { adaptMonthlySettlement, adaptSettlementAccount } from './adapters'
import type { MonthlySettlement, SettlementAccount } from './schemas'

// targetYearMonth 는 yyyy-MM 이다
export type MonthlySettlementParams = GetSettlementParams

export const getMonthlySettlement = async (
  params: MonthlySettlementParams,
): Promise<MonthlySettlement> => {
  const body = await httpClient('pod').get<GetSettlement1Data>('/settlement/v2', { params })
  return adaptMonthlySettlement(body)
}

/** 학원의 정산 계좌. POD 가 아닌 메인 서버가 준다 */
export const getSettlementAccount = async (meta?: RequestMeta): Promise<SettlementAccount> => {
  const body = await httpClient().get<GetSettlementWithIdentificationData>(
    '/academies/settlement-with-identification',
    { meta },
  )
  return adaptSettlementAccount(body.data)
}

/***************** 정산 정보 등록 (본인인증 서버) *****************/
// 본인인증 서버('identify' 클라이언트)는 Swagger 를 내지 않아 2026-10-16 기준 선생님 앱이 보내던 본문을 근거로 적었다.
// 은행명은 서버 Bank enum 의 한글 이름 그대로 보내야 한다(일치하지 않으면 400).
export type SettlementAccountRegistration = {
  name: string
  /** yyyy-MM-dd */
  birthDate: string
  /** 주민등록번호 앞자리-뒷자리 */
  socialId: string
  phoneNumber: string
  bankName: string
  bankAccountNumber: string
}

/** 본인인증을 거쳐 정산 받을 계좌를 등록한다. 응답 본문은 쓰지 않는다 */
export const registerSettlementAccount = async (
  body: SettlementAccountRegistration,
  { preventErrorToast }: Pick<RequestConfig, 'preventErrorToast'> = {},
): Promise<void> => {
  await httpClient('identify').post<unknown>('/identification', body, { preventErrorToast })
}
